module.exports = __webpack_public_path__ + "img/logo_creditall.2941d2d9.png";